export default __webpack_public_path__ + "static/media/forgot-password-v2-dark.593b4f61.svg";